import { render, staticRenderFns } from "./previewFilePage.vue?vue&type=template&id=b98baf9c&scoped=true&"
import script from "./previewFilePage.vue?vue&type=script&lang=js&"
export * from "./previewFilePage.vue?vue&type=script&lang=js&"
import style0 from "./previewFilePage.vue?vue&type=style&index=0&id=b98baf9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98baf9c",
  null
  
)

export default component.exports